import { gql } from '@apollo/client';

export const CREATE_PROCESSING_ASSESSMENT = gql`
  mutation createProcessingAssessment($data: CreateProcessingAssessmentInput!) {
    createProcessingAssessment(data: $data) {
      id
    }
  }
`;
